import { makeStyles } from "@mui/styles";

export const ReceiptHistoryStyle = makeStyles((theme)=>({
    img: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: theme.palette.borderRadius,
        padding: "10px"
    },
}))